import axios from 'axios'

const productionApiOrigin = 'https://api-bff.u-id.net';

const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    responseType: 'blob',
    headers: {
        'Content-Type': 'application/x-protobuf',
        'Accept': 'application/x-protobuf'
    }
});

const useLocalApiProxy =
  process.env.NODE_ENV === 'development' &&
  !process.env.REACT_APP_BASE_URL?.startsWith('http');

if (useLocalApiProxy) {
  API.interceptors.request.use((config) => {
    if (typeof config.url === 'string' && config.url.startsWith(productionApiOrigin)) {
      const relativePath = config.url.slice(productionApiOrigin.length);
      config.url = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
    }
    return config;
  });
}

export default API;
